export default __webpack_public_path__ + "static/media/makeup.6be53550.png";